import { createContext, useContext, useState } from "react";
import { FileSchema } from "../services/Schemas/File";

export interface IFile extends FileSchema {}

export interface IFilesContext {
  newUploadOpen: boolean;
  setNewUploadOpen: (payload: boolean) => void;
  onCloseNewUpload: () => void;
  currentFile: IFile | null;
  setCurrentFile: (payload: IFile | null) => void;
  fileReload: boolean;
  setFileReload: (payload: boolean) => void;
}

const filesContext = createContext<IFilesContext>({
  newUploadOpen: false,
  setNewUploadOpen: () => false,
  onCloseNewUpload: () => false,
  currentFile: null,
  setCurrentFile: (payload: IFile | null) => false,
  fileReload: false,
  setFileReload: (payload: boolean) => false,
});

export function FilesContextProvider(props: any) {
  const [newUploadOpen, setNewUploadOpen] = useState<boolean>(false);
  const [currentFile, setCurrentFile] = useState<IFile | null>(null);
  const [fileReload, setFileReload] = useState<boolean>(false);

  const onCloseNewUpload = () => setNewUploadOpen(false);

  return (
    <filesContext.Provider
      value={{
        newUploadOpen,
        setNewUploadOpen,
        onCloseNewUpload,
        currentFile,
        setCurrentFile,
        fileReload,
        setFileReload,
      }}
      {...props}
    />
  );
}

export const useFilesContext = () => useContext(filesContext);
